import { useState, useEffect } from "react";
import PreguntasTalentoQuiz from "../../../components/test/Quiz/PreguntasTalentoQuiz";
import QuizVideoIntro from "../../../components/test/Quiz/tutorial/QuizVideoIntro";
import Loader from "../../../components/UI/Loader";
import { getPreguntasTalentoStatusService } from "../../../services/preguntasTalentoQuiz/preguntasTalentoQuiz.service";
import "./layout.css";

const PreguntasTalentoQuizPage = () => {
  const [started, setStarted] = useState(false);
  const [continuar, setContinuar] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const data = await getPreguntasTalentoStatusService();
        if (data.todas_completadas) {
          setStarted(true);
        } else if (data.frase_index > 1 || data.talento_index > 1) {
          setContinuar(true);
        }
      } catch {
        // sin sesión → comenzar
      } finally {
        setChecked(true);
      }
    };
    check();
  }, []);

  if (!checked) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader
          center
          size="lg"
          type="dots"
          text="Cargando módulo de fortalezas..."
          delay={0}
        />
      </div>
    );
  }

  if (!started) {
    return (
      <QuizVideoIntro
        tipo="inicio_fortaleza"
        titulo="Fortalezas"
        continuar={continuar}
        onStart={() => setStarted(true)}
      />
    );
  }

  return (
    <div className="quiz-page">
      <PreguntasTalentoQuiz />
    </div>
  );
};

export default PreguntasTalentoQuizPage;
